import { Dialog, DialogContent } from '@mui/material';
import { useEffect } from 'react';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  usePersonalVendeStore,
  type RegistrarPersonaVende
} from '../../stores/personal-vende/personal-vende.store';
import PersonalVendeForm from './PersonaVendeForm';

interface PersonalVendeAddDialogProps {
  open: boolean;
  onClose: () => void;
  onAddSuccess: (newId: number) => void;
}

const PersonalVendeAddDialog = ({ open, onClose, onAddSuccess }: PersonalVendeAddDialogProps) => {
  const { nuevo, registrar } = usePersonalVendeStore();

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore();
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore();

  useEffect(() => {
    nuevo();
    cargarCiudades();
    cargarEstados();
  }, []);

  const handleSave = async (values: RegistrarPersonaVende) => {
    const result = await registrar(values);
    if (result) {
      onAddSuccess(result);
    }
    return result;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <PersonalVendeForm
          esAgregar={true}
          ciudades={ciudades}
          estados={estados}
          onSave={handleSave}
          onClose={onClose}
          reloadCiudades={cargarCiudades}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PersonalVendeAddDialog;
